import { Box, Button, Input, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { getProxyPdaAccount, isValidSolanaAddress } from '../common';
import { PublicKey } from '@solana/web3.js';
import { useAnchorWallet } from '@solana/wallet-adapter-react';
import { Idl, Program } from '@coral-xyz/anchor';
import { useNotify } from './Notify';

interface SetAdminProps {
    proxyProgram:  Program<Idl>
}

export const SetAdmin: React.FC<SetAdminProps> = (props: SetAdminProps) => {
    const [isNewAdminValid, setIsNewAdminValid] = useState<boolean>(true);
    const [newAdmin, setNewAdmin] = useState<string>('');
    const notify = useNotify();

    const wallet = useAnchorWallet();

    const onNewAdminChange = (e: any) => {
        const inputValue = e.target.value;

        const isValidInput = isValidSolanaAddress(inputValue);

        setNewAdmin(inputValue);
        setIsNewAdminValid(isValidInput);
    };

    const setAdmin = async () => {
        if (wallet && newAdmin) {
            const [proxyPdaAccount] = getProxyPdaAccount();

            try {
                const tx = await props.proxyProgram.methods
                    .setAdmin(new PublicKey(newAdmin))
                    .accounts({
                        proxy: proxyPdaAccount,
                        admin: wallet.publicKey,
                    })
                    .rpc();
                notify('success', tx);
            } catch (e) {
                notify('error');
            }
        }
    };

    return <Box>
        <div className='components-row'>
            <Input
                type='text'  // Input type 'text' allows for string input
                placeholder='Enter New Admin'
                value={newAdmin}
                onChange={onNewAdminChange}
                borderColor={isNewAdminValid ? 'gray.200' : 'red.500'}  // Change border color based on validity
            />
            <Button onClick={setAdmin} isDisabled={!isNewAdminValid}>
                Change Admin
            </Button>
        </div>
        {!isNewAdminValid && (
            <Text color='red.500' mt='2' fontSize='sm'>
                {'Please enter a valid Admin address (42-45 characters).'}
            </Text>
        )}
    </Box>;
};
